import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HeaderMenu } from './models/header-menu';
import { HeaderUserData } from './seds-header-user/models/header-user-data.model';
import { HeaderUserMenuButton } from './seds-header-user';
import { SedsTimerComponent } from '../seds-timer/seds-timer.component';

@Component({
    selector: 'seds-header',
    templateUrl: './seds-header.component.html',
    styleUrls: ['./seds-header.component.scss'],
    standalone: false
})
export class SedsHeaderComponent {
  @Input() applicationName!: string;
  @Input() counter: number = 0;
  @Input() headerMenuList!: HeaderMenu[];
  @Input() logoImage!: string;
  @Input() showBadge: boolean = true;
  @Input() showMenu: boolean = true;
  @Input() showTimer: boolean = true;
  @Input() showUser: boolean = true;
  @Input() smallLogoImage!: string;
  @Input() url!: string;
  @Input() userData!: HeaderUserData;
  @Output() actionButtonMenuClick = new EventEmitter<HeaderUserMenuButton>();
  @Output() finishedTime: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('timer') timer!: SedsTimerComponent;

  onButtonItemClick(itemMenu: HeaderUserMenuButton) {
    this.actionButtonMenuClick.emit(itemMenu);
  }

  onFinishedTime(event: number) {
    this.finishedTime.emit(event);
  }

  startTimer(duration: number) {
    this.timer.start(duration);
  }
}
